<ion-header *ngIf="!displayModalCategPermisChanged && !displayModalLicenseNumber && !displayModalCategPermis && !displayModalNEPH && !displayModalJustifSavoirPlus && !displayModalLastObtainedBadge">
  <top-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></top-nav-component>
</ion-header>

<ion-content class="student-documents" [ngClass]="{'z-index-2000': displayModalLicenseNumber || displayModalCategPermis || displayModalNEPH || displayModalJustifSavoirPlus}">

  <bloc-header-comp [compOptions]="{'title': blocHeaderTitle, 'isBackBtn': isBackBtn, 'backTitle': blocHeaderBackTitle, 'url': blocHeaderBackUrl, navigate: 'root'}"></bloc-header-comp>

  <!-- SHIMMER -->
  <!-- <div *ngIf="longLoading && !pageLoaded && !formsConstructed" class="shimmer-wrapper ion-content-container max-width-page">
    <div class="accordion-wrapper">
      <div *ngFor="let item of utils.numberToArray(2)" class="accordion-item">
        <div class="wpe-90 border-radius-6 padding-6 margin-v-6 shimmer"></div>
      </div>
    </div>

    <div class="forms-wrapper">
      <div *ngFor="let item of utils.numberToArray(3)" class="evs-card-ui form-item">
        <div class="wpe-90 border-radius-6 padding-6 margin-v-15 shimmer"></div>
        <div class="wpe-50 border-radius-6 padding-6 margin-v-10 shimmer"></div>
        <div class="wpe-50 border-radius-6 padding-6 margin-v-10 shimmer"></div>
        <div class="wpe-50 border-radius-6 padding-6 margin-v-10 shimmer"></div>
        <div class="wpe-90 border-radius-6 padding-6 margin-v-15 shimmer"></div>
        <div class="wpe-50 border-radius-6 padding-6 margin-v-10 shimmer"></div>
        <div class="wpe-50 border-radius-6 padding-6 margin-v-10 shimmer"></div>
        <div class="wpe-50 border-radius-6 padding-6 margin-v-10 shimmer"></div>
      </div>
    </div>
  </div> -->

  <!-- CONTENT -->
  <div *ngIf="!fetchDocumentsForindexFailed && !fetchStudentsDocumentsByUserIdFailed" class="content-wrapper ion-content-container max-width-page">
    <div class="accordion-wrapper">
      <div class="accordion-item">
        <input type="checkbox" id="item1">
        <label class="accordion-item-title" for="item1"><p>Si tu n’as pas encore le permis de conduire</p><img class="arrow" [src]="'assets/svg/arrowRight.svg'"></label>
        <hr>
        <div class="accordion-item-content">
          Tu dois renseigner :<br>
            <ul>
              <li>
                <strong>Les informations figurant sur ton attestation d'inscription :</strong> Nous avons besoin de ton NEPH, nom de famille, date de naissance et catégorie de permis.
                Cela nous permet de vérifier que tu es bien inscrit dans le registre de la préfecture.
                Tu dois donc renseigner les informations comme elles figurent sur ton dossier cerfa 02 ou "attestation d'inscription".
              </li>
              <li>
                <strong>Ton justificatif de réussite au code de la route :</strong> Si tu as passé le code avec un organisme agréé (SGS, Code’nGo, La Poste...),
                il s’agit du mail t’informant que tu as obtenu ton code.
                Si tu l'as passé en préfecture, il s'agit du verso de ton cerfa 02 sur lequel figure un tampon avec ton résultat de code.
              </li>
            </ul>
        </div>
      </div>
      <div class="accordion-item">
        <input type="checkbox" id="item2">
        <label class="accordion-item-title" for="item2"><p>Si tu as déjà le permis de conduire</p><img class="arrow" [src]="'assets/svg/arrowRight.svg'"></label>
        <hr>
        <div class="accordion-item-content">Si tu souhaites prendre des leçons de conduite et que tu as déjà le permis, alors il te suffit de mettre en ligne recto/verso une photo de ton permis.</div>
      </div>
    </div>

    <div class="forms-wrapper">

      <!----------------------------------------->
      <!-- FORMULARE ATTESTATION D'INSCRIPTION -->
      <!----------------------------------------->
      <div class="evs-card-ui form-item">
        <p class="callout bold">
          Attestation d'inscription
          <ion-spinner *ngIf="!initDataReady" class="spinners" name="circles"></ion-spinner>
        </p>
          <div *ngIf="!formsConstructed">
            <div class="wpe-100 hpi-55 border-radius-16 margin-bottom-16 shimmer"></div>
            <div class="wpe-100 hpi-55 border-radius-16 margin-bottom-16 shimmer"></div>
            <div class="wpe-100 hpi-55 border-radius-16 margin-bottom-16 shimmer"></div>
            <div class="wpe-100 hpi-55 border-radius-16 margin-bottom-16 shimmer"></div>
            <div class="wpe-100 hpi-55 border-radius-16 margin-bottom-16 shimmer"></div>
            <div class="wpe-100 hpi-55 border-radius-16 shimmer"></div>
          </div>
          <form *ngIf="(!registrationCertificate || (!!registrationCertificate && updateFormRegistrationCertificate)) && formsConstructed" class="evs-form" [formGroup]="registrationCertificateForm" autocomplete="off" class="evs-form" (ngSubmit)="submitRegistrationCertificateForm(registrationCertificateForm.value)">
            <div>
              <input type="text" formControlName="firstName" id="registrationCertificatePrenom" autocomplete="off" data-lpignore="true">
              <label for="registrationCertificatePrenom" [ngClass]="{'label-up': !!getRegistrationCertificateForm.firstName.value && getRegistrationCertificateForm.firstName.value !== ''}">Premier prénom uniquement</label>
            </div>
            <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getRegistrationCertificateForm.firstName}"></ng-container>
            <p class="field-indicator">
              Comme inscrit sur ton <span class="field-indicator-modale" (click)="openModalNEPH()">document officiel</span>, ponctuation et accents compris
            </p>

            <div>
              <input type="text" formControlName="lastName" id="registrationCertificateNom" autocomplete="off" data-lpignore="true">
              <label for="registrationCertificateNom" [ngClass]="{'label-up': !!getRegistrationCertificateForm.lastName.value && getRegistrationCertificateForm.lastName.value !== ''}">Nom de famille</label>
            </div>
            <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getRegistrationCertificateForm.lastName}"></ng-container>
            <p class="field-indicator">
              Comme inscrit sur ton <span class="field-indicator-modale" (click)="openModalNEPH()">document officiel</span>, ponctuation et accents compris
            </p>

            <div>
              <autocomplete-local-comp *ngIf="showAutocompletes" [compOptions]="{type: 'select', 'placeholder': 'Sexe', 'fields': ['name'], 'fieldname': 'name', 'output': 'value', value: registrationCertificate?.gender, selectData: genderList}" (inputSelected)="getAutocompleteSelectValue(registrationCertificateForm, 'gender', $event)"></autocomplete-local-comp>
            </div>

            <!-- <div class="margin-bottom-30">
              <label for="registrationCertificateGender" class="label-up">Sexe</label>
              <ion-select placeholder="Choisir" [interfaceOptions]="{header: 'Sexe'}" cancelText="Annuler" [value]="student?.gender" formControlName="gender" id="registrationCertificateGender" autocomplete="off" data-lpignore="true">
                <ion-select-option *ngFor="let gender of genderList" [value]="gender.value">{{gender.name}}</ion-select-option>
              </ion-select>
              <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getRegistrationCertificateForm.gender}"></ng-container>
            </div> -->

            <div>
              <input type="date" formControlName="birthdate" id="registrationCertificateBirthdate" autocomplete="off" data-lpignore="true">
              <label for="registrationCertificateBirthdate" class="label-up">Date de naissance</label>
            </div>
            <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getRegistrationCertificateForm.birthdate}"></ng-container>
            
            <!-- <input class="display-none" type="checkbox" formControlName="born_abroad" id="registrationCertificateOptin" [checked]="registrationCertificateOptin" autocomplete="off" data-lpignore="true">
            <div class="optin margin-bottom-16">
              <span class="inline-block" (click)="setCheckbox('registrationCertificateOptin')">
                <img *ngIf="!registrationCertificateOptin" src="assets/svg/checkbox.svg" height="18" alt="EnVoitureSimone">
                <img *ngIf="registrationCertificateOptin" src="assets/2022/icons/checkbox-on.svg" height="18" alt="EnVoitureSimone">
              </span>
              <p class="field-indicator inline-block text-left"><span (click)="setCheckbox('registrationCertificateOptin')">Je suis né à l'étranger</span></p>
            </div> -->

            <!-- <div *ngIf="registrationCertificateOptin">
              <input type="text" formControlName="birth_location" id="registrationCertificateBirthLocationText" autocomplete="off" data-lpignore="true">
              <label for="registrationCertificateBirthLocation" class="label-up">Lieu de naissance</label>
            </div>
            <ng-container *ngIf="registrationCertificateOptin" [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getRegistrationCertificateForm.birth_location}"></ng-container>

            <div *ngIf="!registrationCertificateOptin">
              <autocomplete-comp id="registrationCertificateBirthLocationPostalCode" [compOptions]="{'id': 'registrationCertificateBirthLocationPostalCodeAutocomplete', 'value': cleanedPostalCode, 'service': postalCodeService, 'fields': ['pc_value', 'name', 'pc_id'], 'fieldname': 'name', 'output': 'pc_id', 'placeholder': 'Lieu de naissance'}" (inputSelected)="getAutocompleteValuePostalCode($event)"></autocomplete-comp>
            </div> -->

            <div>
              <input *ngIf="!updateFormRegistrationCertificate" type="text" formControlName="NEPHNumber" id="registrationCertificateNEPH" autocomplete="off" data-lpignore="true">
              <input *ngIf="updateFormRegistrationCertificate" type="text" formControlName="NEPHNumber" id="registrationCertificateNEPH" autocomplete="off" data-lpignore="true" disabled class="text-neutral-400">
              <label for="registrationCertificateNEPH" [ngClass]="{'label-up': !!getRegistrationCertificateForm.NEPHNumber.value && getRegistrationCertificateForm.NEPHNumber.value !== ''}">Numéro NEPH</label>
            </div>
            <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getRegistrationCertificateForm.NEPHNumber}"></ng-container>
            <p class="field-indicator">
              Numéro à 12 chiffres. <span class="field-indicator-modale" (click)="openModalNEPH()">Où le trouver&nbsp;?</span>
            </p>

            <div>
              <autocomplete-local-comp *ngIf="showAutocompletes" [compOptions]="{type: 'select', 'placeholder': 'Catégorie de permis', 'fields': ['name'], 'fieldname': 'name', 'output': 'value', value: registrationCertificate?.categ_permis, selectData: licenseList}" (inputSelected)="getAutocompleteSelectValue(registrationCertificateForm, 'license', $event)"></autocomplete-local-comp>
            </div>

            <!-- <div class="margin-bottom-30">
              <label for="registrationCertificateLicense" class="label-up">Catégorie de permis</label>
              <div class="field-indicator">
                <span class="field-indicator-modale" (click)="openModalCategPermis()">Où la trouver&nbsp;?</span>
              </div>
              <ion-select placeholder="Choisir" [interfaceOptions]="{header: 'Catégorie de permis'}" cancelText="Annuler" [value]="'Permis B'" formControlName="license" id="registrationCertificateLicense" autocomplete="off" data-lpignore="true">
                <ion-select-option *ngFor="let license of licenseList" [value]="license.value">{{license.name}}</ion-select-option>
              </ion-select>
              <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getRegistrationCertificateForm.license}"></ng-container>
            </div> -->

            <div *ngIf="(registrationCertificateForm.touched || !registrationCertificateForm.pristine) && !!showRegistrationCertificateFormErrors && !registrationCertificateForm.valid" class="margin-top-20 margin-bottom-20 text-center text-warning">
              <span class="animated fadeIn">
                Nous n'avons pu enregistrer tes informations
                <br>car certains champs sont invalides
              </span>
            </div>
            <loading-button-comp class="wpe-100" [compOptions]="{loading: isRegistrationCertificateFormUploading, type: 'submit', valid: registrationCertificateForm.valid, disabled: !registrationCertificateForm.valid || !initDataReady, spinnerColor: 'text-white', text: 'Envoyer'}" (hasClicked)="handleClick($event)"></loading-button-comp>
          </form>

          <ng-container *ngIf="!!registrationCertificate && formsConstructed && !updateFormRegistrationCertificate">
            <div *ngIf="!!registrationCertificate && registrationCertificate.state === 'accepted'">
              <p class="form-sent-display">
                <span class="confirmed">Validé</span> le {{ registrationCertificate.confirmed_at | date:"dd/MM/yyyy" }}.
              </p>
              <p class="form-sent-label">Premier prénom uniquement</p>
              <p class="form-sent-value">{{ registrationCertificate.first_name }}</p>
              <p class="form-sent-label">Nom de famille</p>
              <p class="form-sent-value">{{ registrationCertificate.family_name }}</p>
              <p class="form-sent-label">Sexe</p>
              <p class="form-sent-value">{{ (registrationCertificate.gender === 'f') ? 'Femme' : (registrationCertificate.gender === 'h') ? 'Homme' : registrationCertificate.gender }}</p>
              <p class="form-sent-label">Date de naissance</p>
              <p class="form-sent-value">{{ registrationCertificate.dob | date:"dd/MM/yyyy" }}</p>
              <p class="form-sent-label">Numéro NEPH</p>
              <p class="form-sent-value">{{ registrationCertificate.number_neph }}</p>
              <p class="form-sent-label">Catégorie de permis</p>
              <p class="form-sent-value">{{ registrationCertificate.categ_permis }}</p>
            </div>

            <div *ngIf="!!registrationCertificate && registrationCertificate.state === 'to_validate'">
              <p class="form-sent-display">
                <span class="waiting">En attente</span> de validation par l'équipe d'En Voiture Simone.
              </p>
            </div>
            
            <div *ngIf="!!registrationCertificate && ((registrationCertificate.assets.data.length > 0) || (formsConstructed && !updateFormRegistrationCertificate && registrationCertificate.state !== 'to_validate' && registrationCertificate.categ_permis !== 'Permis B'))" class="button-wrapper">
              <button *ngIf="formsConstructed && !updateFormRegistrationCertificate && registrationCertificate.state !== 'to_validate' && registrationCertificate.categ_permis !== 'Permis B'" class="btn update-form" [ngClass]="{'light': registrationCertificate.assets.data.length > 0}" (click)="updateFormRegistrationCertificateFn()">
                Modifier mes informations
              </button>
              <button *ngIf="registrationCertificate.assets.data.length > 0" class="btn view-file" (click)="openLink('registrationCertificateFile')">
                Voir mon justificatif
              </button>
            </div>
          </ng-container>
      </div>

      <!--------------------------------------------->
      <!-- FORMULARE JUSTIFICATIF CODE DE LA ROUTE -->
      <!--------------------------------------------->
      <div class="evs-card-ui form-item">
        <p class="callout bold">
          Justificatif code de la route
          <ion-spinner *ngIf="!initDataReady" class="spinners" name="circles"></ion-spinner>
        </p>
        <div *ngIf="!formsConstructed">
          <div class="wpe-100 hpi-55 border-radius-16 margin-bottom-16 shimmer"></div>
          <div class="wpe-100 hpi-55 border-radius-16 margin-bottom-16 shimmer"></div>
          <div class="wpe-100 hpi-55 border-radius-16 shimmer"></div>
        </div>
        <form *ngIf="!drivingTheoryCertificate && formsConstructed" class="evs-form" [formGroup]="drivingTheoryCertificateForm" autocomplete="off" class="evs-form" (ngSubmit)="submitDrivingTheoryCertificateForm(drivingTheoryCertificateForm.value)">
          
          <p class="file-upload-indicator">Photographie lisible ou scan du document original (5 Mo maximum)</p>

          <div>
            <div class="fake-field">{{drivingTheoryCertificateFileName}}</div>
            <input
              #drivingTheoryCertificateFileInput
              type="file"
              formControlName="drivingTheoryCertificateFile"
              accept="image/jpeg,image/png,application/pdf"
              id="drivingTheoryCertificateFile"
              data-lpignore="true"
              (change)="processFile('drivingTheoryCertificate', $event)"
            >
            <label for="drivingTheoryCertificateFile" [ngClass]="{'label-up': !!drivingTheoryCertificateFileName && drivingTheoryCertificateFileName !== ''}">Importer un document</label>
            <div *ngIf="!!getDrivingTheoryCertificateForm.drivingTheoryCertificateFile.value && getDrivingTheoryCertificateForm.drivingTheoryCertificateFile.value !== ''" class="evs_delete" (click)="deleteFile(getDrivingTheoryCertificateForm.drivingTheoryCertificateFile, 'drivingTheoryCertificate')">
              <img src="assets/svg/tunnel-delete-ico.svg" alt="EnvoitureSimone">
            </div>
          </div>
          <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getDrivingTheoryCertificateForm.drivingTheoryCertificateFile}"></ng-container>

          <!-- <div>
            <div class="btn" (click)="doUpload('drivingTheoryCertificate')" [hidden]="!!drivingTheoryCertificateFile">
              Choisir un fichier
              <input #drivingTheoryCertificateFileInput
                style="display: none"
                type="file"
                accept="image/jpeg,image/png,application/pdf"
                id="drivingTheoryCertificateFile"
                data-lpignore="true"
                (change)="processFile($event)">
            </div>
            <div class="change-file btn" (click)="cancelUpload('drivingTheoryCertificate')" [hidden]="!drivingTheoryCertificateFile">
              <p><img *ngIf="drivingTheoryCertificateFileName === 'Fichier sélectionné'" class="selected" alt="EnVoitureSimone" src="assets/svg/form-valid.svg" width="20">{{ drivingTheoryCertificateFileName }}</p>
              <img class="close" [src]="'assets/2022/icons/close-off.svg'">
            </div>
            <ng-container [ngTemplateOutlet]="errorTemplateFile" [ngTemplateOutletContext]="{dirty: drivingTheoryCertificateFileDirty, file: drivingTheoryCertificateFile}"></ng-container>
          </div> -->

          <div>
            <input type="date" formControlName="drivingTheoryCertificateDate" id="drivingTheoryCertificateDate" autocomplete="off" data-lpignore="true" [max]="maxDate">
            <label for="drivingTheoryCertificateDate">Date de l'examen du code</label>
          </div>
          <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getDrivingTheoryCertificateForm.drivingTheoryCertificateDate}"></ng-container>
          
          <input class="display-none" type="checkbox" formControlName="drivingTheoryCertificateOptin" id="drivingTheoryCertificateOptin" [checked]="drivingTheoryCertificateOptin" autocomplete="off" data-lpignore="true">
          <div class="optin margin-bottom-16">
            <span class="inline-block" (click)="setCheckbox('drivingTheoryCertificateOptin')">
              <img *ngIf="!drivingTheoryCertificateOptin" src="assets/svg/checkbox.svg" height="18" alt="EnVoitureSimone">
              <img *ngIf="drivingTheoryCertificateOptin" src="assets/2022/icons/checkbox-on.svg" height="18" alt="EnVoitureSimone">
            </span>
            <p class="field-indicator inline-block text-left"><span (click)="setCheckbox('drivingTheoryCertificateOptin')">Je certifie sur l’honneur que ces renseignements sont exacts et que j'ai obtenu mon code de la route il y a moins de 5 ans. Si mon justificatif n’est pas valide, je ne pourrai pas passer l’examen du permis. </span><br *ngIf="isDesktop"><span class="field-indicator-modale" (click)="showModalJustifSavoirPlus()">En savoir plus</span></p>
          </div>

          <div *ngIf="(drivingTheoryCertificateForm.touched || !drivingTheoryCertificateForm.pristine) && !!showDrivingTheoryCertificateFormErrors && !drivingTheoryCertificateForm.valid && !!drivingTheoryCertificateFile" class="margin-top-20 margin-bottom-20 text-center text-warning">
            <span class="animated fadeIn">
              Nous n'avons pu enregistrer tes informations
              <br>car certains champs sont invalides
            </span>
          </div>
          <loading-button-comp class="wpe-100" [compOptions]="{loading: isDrivingTheoryCertificateFormUploading, type: 'submit', valid: (drivingTheoryCertificateForm.valid && !!drivingTheoryCertificateFile), disabled: (!drivingTheoryCertificateForm.valid || !drivingTheoryCertificateFile || !initDataReady), spinnerColor: 'text-white', text: 'Envoyer'}" (hasClicked)="handleClick($event)"></loading-button-comp>
        </form>

        <ng-container *ngIf="!!drivingTheoryCertificate && formsConstructed">
          <p *ngIf="!!drivingTheoryCertificate && drivingTheoryCertificate.state === 'accepted'" class="form-sent-display">
            <span class="confirmed">Validé</span> le {{ drivingTheoryCertificate.confirmed_at | date:"dd/MM/yyyy" }}.
          </p>

          <!-- <p *ngIf="!!drivingTheoryCertificate && drivingTheoryCertificate.state === 'to_validate'" class="form-sent-display">
            <span class="waiting">En attente</span> de validation par l'équipe d'En Voiture Simone.
          </p> -->

          <div *ngIf="!!drivingTheoryCertificate && drivingTheoryCertificate.assets.data.length > 0" class="button-wrapper">
            <button class="btn view-file" (click)="openLink('drivingTheoryCertificateFile')">
              Voir mon justificatif
            </button>

            <button *ngIf="drivingTheoryCertificate.state === 'to_validate'" class="btn light delete-file" (click)="openModalDeleteDocument('drivingTheoryCertificate')">
              Supprimer
            </button>
          </div>
        </ng-container>
      </div>

      <!---------------------------------->
      <!-- FORMULARE PERMIS DE CONDUIRE -->
      <!---------------------------------->
      <div class="evs-card-ui form-item">
        <p class="callout bold">
          Permis de conduire
          <ion-spinner *ngIf="!initDataReady" class="spinners" name="circles"></ion-spinner>
        </p>
        <div *ngIf="!formsConstructed">
          <div class="wpe-100 hpi-55 border-radius-16 margin-bottom-16 shimmer"></div>
          <div class="wpe-100 hpi-55 border-radius-16 margin-bottom-16 shimmer"></div>
          <div class="wpe-100 hpi-55 border-radius-16 margin-bottom-16 shimmer"></div>
          <div class="wpe-100 hpi-55 border-radius-16 margin-bottom-16 shimmer"></div>
          <div class="wpe-100 hpi-55 border-radius-16 shimmer"></div>
        </div>
        <form *ngIf="!drivingLicense && formsConstructed" [formGroup]="drivingLicenseForm" autocomplete="off" class="evs-form" (ngSubmit)="submitDrivingLicenseForm(drivingLicenseForm.value)">
          
          <p class="file-upload-indicator">Photographie lisible ou scan du document original (5 Mo maximum)</p>

          <div>
            <div class="fake-field">{{drivingLicenseRectoFileName}}</div>
            <input
              #drivingLicenseRectoFileInput
              type="file"
              formControlName="drivingLicenseRectoFile"
              accept="image/jpeg,image/png,application/pdf"
              id="drivingLicenseRectoFile"
              data-lpignore="true"
              (change)="processFile('drivingLicenseRecto', $event)"
            >
            <label for="drivingLicenseRectoFile" [ngClass]="{'label-up': !!drivingLicenseRectoFileName && drivingLicenseRectoFileName !== ''}">Importer le recto</label>
            <div *ngIf="!!getDrivingLicenseForm.drivingLicenseRectoFile.value && getDrivingLicenseForm.drivingLicenseRectoFile.value !== ''" class="evs_delete" (click)="deleteFile(getDrivingLicenseForm.drivingLicenseRectoFile, 'drivingLicenseRecto')">
              <img src="assets/svg/tunnel-delete-ico.svg" alt="EnvoitureSimone">
            </div>
          </div>
          <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getDrivingLicenseForm.drivingLicenseRectoFile}"></ng-container>
         
          <div>
            <div class="fake-field">{{drivingLicenseVersoFileName}}</div>
            <input
              #drivingLicenseVersoFileInput
              type="file"
              formControlName="drivingLicenseVersoFile"
              accept="image/jpeg,image/png,application/pdf"
              id="drivingLicenseVersoFile"
              data-lpignore="true"
              (change)="processFile('drivingLicenseVerso', $event)"
            >
            <label for="drivingLicenseVersoFile" [ngClass]="{'label-up': !!drivingLicenseVersoFileName && drivingLicenseVersoFileName !== ''}">Importer le verso</label>
            <div *ngIf="!!getDrivingLicenseForm.drivingLicenseVersoFile.value && getDrivingLicenseForm.drivingLicenseVersoFile.value !== ''" class="evs_delete" (click)="deleteFile(getDrivingLicenseForm.drivingLicenseVersoFile, 'drivingLicenseVerso')">
              <img src="assets/svg/tunnel-delete-ico.svg" alt="EnvoitureSimone">
            </div>
          </div>
          <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getDrivingLicenseForm.drivingLicenseVersoFile}"></ng-container>

          <!-- <div class="margin-bottom-30">
            <p class="file-upload-label">
              Recto
            </p>
            <div class="btn" (click)="doUpload('drivingLicenseRecto')" [hidden]="!!drivingLicenseRectoFile">
              Choisir un fichier
              <input #drivingLicenseRectoFileInput
                style="display: none"
                type="file"
                accept="image/jpeg,image/png,application/pdf"
                id="drivingLicenseRectoFile"
                data-lpignore="true"
                (change)="processFile($event)">
            </div>
            <div class="change-file btn" (click)="cancelUpload('drivingLicenseRecto')" [hidden]="!drivingLicenseRectoFile">
              <p><img *ngIf="drivingLicenseRectoFileName === 'Fichier sélectionné'" class="selected" alt="EnVoitureSimone" src="assets/svg/form-valid.svg" width="20">{{ drivingLicenseRectoFileName }}</p>
              <img class="close" [src]="'assets/2022/icons/close-off.svg'">
            </div>
            <ng-container [ngTemplateOutlet]="errorTemplateFile" [ngTemplateOutletContext]="{dirty: drivingLicenseRectoFileDirty, file: drivingLicenseRectoFile}"></ng-container>
          </div>

          <div class="margin-bottom-30">
            <p class="file-upload-label">
              Verso
            </p>
            <div class="btn" (click)="doUpload('drivingLicenseVerso')" [hidden]="!!drivingLicenseVersoFile">
              Choisir un fichier
              <input #drivingLicenseVersoFileInput
                style="display: none"
                type="file"
                accept="image/jpeg,image/png,application/pdf"
                id="drivingLicenseVersoFile"
                data-lpignore="true"
                (change)="processFile($event)">
            </div>
            <div class="change-file btn" (click)="cancelUpload('drivingLicenseVerso')" [hidden]="!drivingLicenseVersoFile">
              <p><img *ngIf="drivingLicenseVersoFileName === 'Fichier sélectionné'" class="selected" alt="EnVoitureSimone" src="assets/svg/form-valid.svg" width="20">{{ drivingLicenseVersoFileName }}</p>
              <img class="close" [src]="'assets/2022/icons/close-off.svg'">
            </div>
            <ng-container [ngTemplateOutlet]="errorTemplateFile" [ngTemplateOutletContext]="{dirty: drivingLicenseVersoFileDirty, file: drivingLicenseVersoFile}"></ng-container>
          </div> -->
          <ng-container *ngIf="drivingLicenseType === studentDocumentsService.documentTypeDrivingLicenseNEPH">
            <div>
              <input type="text" formControlName="licenseNumber" id="drivingLicenseNumber" autocomplete="off" data-lpignore="true">
              <label for="drivingLicenseNumber" [ngClass]="{'label-up': !!getDrivingLicenseForm.licenseNumber.value && getDrivingLicenseForm.licenseNumber.value !== ''}">Numéro de permis</label>
            </div>
            <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getDrivingLicenseForm.licenseNumber}"></ng-container>
            <div class="field-indicator">
              <span class="field-indicator-modale" (click)="openModalLicenseNumber()">Où le trouver&nbsp;?</span>
            </div>
  
            <div>
              <autocomplete-local-comp *ngIf="showAutocompletes" [compOptions]="{type: 'select', 'placeholder': 'Catégorie de permis', 'fields': ['name'], 'fieldname': 'name', 'output': 'value', value: '', selectData: licenseList}" (inputSelected)="getAutocompleteSelectValue(drivingLicenseForm, 'license', $event)"></autocomplete-local-comp>
            </div>
          </ng-container>

          <!-- <div class="margin-bottom-30" *ngIf="drivingLicenseType === studentDocumentsService.documentTypeDrivingLicenseNEPH">
            <label for="drivingLicenseLicense" class="label-up">Catégorie de permis</label>
            <div class="field-indicator">
              La catégorie de permis liée à ce document (Permis A, Permis B...)
            </div>
            <ion-select placeholder="Choisir" [interfaceOptions]="{header: 'Catégorie de permis'}" cancelText="Annuler" [value]="'Permis B'" formControlName="license" id="drivingLicenseLicense" autocomplete="off" data-lpignore="true">
              <ion-select-option *ngFor="let license of licenseList" [value]="license.value">{{license.name}}</ion-select-option>
            </ion-select>
            <ng-container [ngTemplateOutlet]="errorTemplate" [ngTemplateOutletContext]="{field: getDrivingLicenseForm.license}"></ng-container>
          </div> -->

          <div *ngIf="(drivingLicenseForm.touched || !drivingLicenseForm.pristine) && !!showDrivingLicenseFormErrors && !drivingLicenseForm.valid && !drivingLicenseRectoFile && !drivingLicenseVersoFile" class="margin-top-20 margin-bottom-20 text-center text-warning">
            <span class="animated fadeIn">
              Nous n'avons pu enregistrer tes informations
              <br>car certains champs sont invalides
            </span>
          </div>
          <loading-button-comp class="wpe-100" [compOptions]="{loading: isDrivingLicenseFormUploading, type: 'submit', valid: (drivingLicenseForm.valid && !!drivingLicenseRectoFile && !!drivingLicenseVersoFile), disabled: (!drivingLicenseForm.valid || !drivingLicenseRectoFile || !drivingLicenseVersoFile || !initDataReady), spinnerColor: 'text-white', text: 'Envoyer'}" (hasClicked)="handleClick($event)"></loading-button-comp>
        </form>

        <ng-container *ngIf="!!drivingLicense && formsConstructed">
          <p *ngIf="!!drivingLicense && drivingLicense.state === 'accepted'" class="form-sent-display">
            <span class="confirmed">Validé</span> le {{ drivingLicense.confirmed_at | date:"dd/MM/yyyy" }}.
          </p>
  
          <p *ngIf="!!drivingLicense && drivingLicense.state === 'to_validate'" class="form-sent-display">
            <span class="waiting">En attente</span> de validation par l'équipe d'En Voiture Simone.
          </p>
  
          <div *ngIf="!!drivingLicense && drivingLicense.assets.data.length > 0" class="button-wrapper">
            <button class="btn view-file" (click)="openLink('drivingLicenseRectoFile')">
              Voir le recto
            </button>
  
            <button class="btn view-file" (click)="openLink('drivingLicenseVersoFile')">
              Voir le verso
            </button>
  
            <button *ngIf="drivingLicense.state === 'to_validate'" class="btn light delete-file" (click)="openModalDeleteDocument('drivingLicense')">
              Supprimer
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- RGPD -->
  <p class="rgpd-text">Pour en savoir plus sur la gestion de tes données personnelles <a class="rgpd-link" href="https://www.envoituresimone.com/politique-confidentialite">consulte notre politique de confidentialité</a>.</p>

  <!-- FAILED -->
  <div *ngIf="pageLoaded && formsConstructed && (fetchDocumentsForindexFailed || fetchStudentsDocumentsByUserIdFailed)" class="content-wrapper ion-content-container max-width-page">
    <bloc-error-comp></bloc-error-comp>
  </div>
  
  <!-------------------------->
  <!-- FORM TEMPLATE ERRORS -->
  <!-------------------------->
  <ng-template #errorTemplate let-field="field">
    <ng-container *ngIf="!field.valid && (field.dirty || field.touched)">
      <div class="field-error" *ngIf="field.errors?.required">Ce champ est obligatoire</div>
      <div class="field-error" *ngIf="field.errors?.pattern">Ce champ n'est pas valide</div>
      <div class="field-error" *ngIf="field.errors?.minlength">Doit contenir au moins 6 caractères</div>
      <div class="field-error" *ngIf="field.errors?.maxlength">Nombre de caractères maximum dépassé</div>
      <div class="field-error" *ngIf="field.errors?.validatePasswords">Les mots de passe ne correspondent pas</div>
      <!-- {{field.errors?.validatePasswords | json}} -->
    </ng-container>
  </ng-template>

  <ng-template #errorTemplateFile let-dirty="dirty" let-file="file">
    <ng-container *ngIf="dirty && !file">
      <div class="field-error field-error-file">Ce champ est obligatoire</div>
      <!-- {{field.errors?.validatePasswords | json}} -->
    </ng-container>
  </ng-template>

  <!------------>
  <!-- MODALS -->
  <!------------>
  <modal-comp [compOptions]="{'id': 'customModalUpload1', size: 'small'}" *ngIf="showModal1" (canClose)="hideModal1()">
    <div class="text-center">{{errorMsg}}</div>
  </modal-comp>

  <modal-comp [compOptions]="{'id': 'customModalError', dynamicHeight: true}" *ngIf="!!showModalErrorServer" (canClose)="hideModalErrorServer()">
    <div class="text-center">
      <h4 class="margin-bottom-25">Oups !</h4>
      <ng-container *ngIf="showModalErrorServerText != 'duplicateNEPHCase'">
        <p>
          <span [innerHTML]="showModalErrorServerText"></span>
          <ng-container *ngIf="isDesktop"><br><br></ng-container>
          <ng-container *ngIf="!isDesktop"><br></ng-container>
          Pour remettre tout en ordre, direction notre FAQ où un <a class="link" (click)="openLink('nephReject')">article</a> t'attend avec toutes les étapes à suivre.
        </p>
        <button class="btn full-width margin-top-15" (click)="hideModalErrorServer()">Essayer à nouveau</button>
      </ng-container>

      <ng-container *ngIf="showModalErrorServerText === 'duplicateNEPHCase'">
        <p>
          Le <span class="bold">numéro NEPH</span> renseigné semble être enregistré sur un autre compte.
          <br><br>
          Afin de tout mettre en ordre, contacte le service client !
        </p>
        <button class="btn full-width margin-top-15" (click)="openLink('supportNewRequest')">Contacter le service client</button>
      </ng-container>
    </div>
  </modal-comp>

  <modal-comp [compOptions]="{'id': 'customModalUpload3', size: 'small', position: 'bottom', closable: false}" [ngClass]="{'device-decal-modal-bottom': isCordova,'noHover': hoverModaleDisable}" *ngIf="showModalUploadMobile" (canClose)="hideModalUploadMobile()">
    <div class="text-center">
      <div class="uploadMobileChoice" (click)="getPhoto()">Prendre une Photo</div>
      <div class="uploadMobileChoice" (click)="getFromGallery()">Choisir dans la galerie</div>
    </div>
  </modal-comp>
  
  <modal-comp class="text-center form-modals" [compOptions]="{'id': 'customModalCategPermisChanged', closable: false}" *ngIf="displayModalCategPermisChanged" (canClose)="hideModalCategPermisChanged()" #modalCategPermisChanged>
    <h4>Attention&nbsp;!</h4>
    <p>Tu as indiqué une catégorie différente de la catégorie B (permis voiture classique).<br><br>
      Tu pourras t'inscrire à l’examen du code de la route sans problème. Cependant, il ne sera pas possible d’effectuer des heures de conduite avec notre auto-école car nous dispensons uniquement des leçons pour le permis B.<br><br>
      Si tu penses que c’est une erreur, tu peux contacter notre <span class="indicator-modale" (click)="openLink('supportNewRequest')">service client</span> pour trouver une solution.</p>
    <button class="btn" (click)="callHideModalCategPermisChanged()">J'ai compris</button>
  </modal-comp>
  
  <modal-comp class="text-center form-modals" [compOptions]="{'id': 'customModalDeleteDocument', closable: false}" *ngIf="displayModalDeleteDocument" (canClose)="hideModalDeleteDocument()" #modalDeleteDocument>
    <h4>Attention&nbsp;!</h4>
    <p>{{documentDeleteText}}</p>
    <div class="button-wrapper">
      <button class="btn light" (click)="callHideModalDeleteDocument()">Annuler</button>
      <loading-button-comp class="wpe-100" [compOptions]="{loading: showModalDeleting, text: 'Oui', spinnerColor: 'text-white'}" (loadingButtonClicked)="deleteDocument($event)"></loading-button-comp>
    </div>
  </modal-comp>

  <modal-comp [compOptions]="{'id': 'customModalUpload2', size: 'small', closable: false}" *ngIf="showModalUpload" (canClose)="hideModalUpload()">
    <div class="text-center">
      <ion-spinner class="customSpinner" name="bubbles"></ion-spinner>
      <br>
        Ton document est en cours<br>de chargement...
    </div>
  </modal-comp>
  
  <modal-comp class="text-center form-modals" [compOptions]="{'id': 'customModalNEPH', 'size': 'full', closable: false}" *ngIf="displayModalNEPH" (canClose)="hideModalNEPH()" #modalNEPH>
    <h4>Attestation d'inscription ou cerfa 02 (dans l'étape Renseigner mon NEPH)</h4>
    <p>Quand tu t'inscris à une formation du permis de conduire, tu obtiens un numéro de candidat : LE NEPH. Ce numéro est inscrit sur ce qu'on appelle un cerfa 02 ou une attestation d'inscription.<br>
      Si tu as été inscrit en auto-école avant l'année 2017, tu possèdes un cerfa 02 :</p>
    <img [src]="'assets/png/student-documents/neph-cerfa.png'">
    <p>Si tu as été inscrit après l’année 2017, tu possèdes une attestation d’inscription :</p>
    <img [src]="'assets/png/student-documents/neph-registration-certificate.png'">
    <button class="btn full-width" (click)="callHideModalNEPH()">Fermer</button>
  </modal-comp>
  
  <modal-comp class="text-center form-modals" [compOptions]="{'id': 'customModalCategPermis', 'size': 'full', closable: false}" *ngIf="displayModalCategPermis" (canClose)="hideModalCategPermis()" #modalCategPermis>
    <h4>Où trouver ma catégorie de permis&nbsp;?</h4>
    <p>La catégorie de permis indique le type de permis que tu prépares et pour lequel l'administration t'a donné l'autorisation de suivre une formation :<br><br>
      Sur une attestation d'inscription :</p>
    <img [src]="'assets/png/student-documents/categ-permis-registration-certificate.png'">
    <p>Sur un cerfa 02 :</p>
    <img [src]="'assets/png/student-documents/categ-permis-cerfa.png'">
    <p>Sur un permis de conduire :</p>
    <img [src]="'assets/png/student-documents/categ-permis-permis.png'">
    <button class="btn full-width" (click)="callHideModalCategPermis()">Fermer</button>
  </modal-comp>
  
  <modal-comp class="text-center form-modals" [compOptions]="{'id': 'customModalLicenseNumber', 'size': 'full', closable: false}" *ngIf="displayModalLicenseNumber" (canClose)="hideModalLicenseNumber()" #modalLicenseNumber>
    <h4>Où trouver mon numéro de permis&nbsp;?</h4>
    <p>Sur le nouveau permis :</p>
    <img [src]="'assets/png/student-documents/numero-permis-nouveau.png'">
    <p>Sur un ancien permis :</p>
    <img [src]="'assets/png/student-documents/numero-permis-ancien.png'">
    <button class="btn full-width" (click)="callHideModalLicenseNumber()">Fermer</button>
  </modal-comp>
  
  <modal-comp [compOptions]="{'id': 'customModalJustifSavoirPlus', size: isDesktop ? 'large' : 'full', dynamicHeight: true, closable: false}" *ngIf="displayModalJustifSavoirPlus" (canClose)="hideModalJustifSavoirPlus()" #modalJustifSavoirPlus>
    <h4>L’importance du justificatif de code</h4>
    <p>🚗&nbsp;&nbsp;<b>Accéder à la conduite</b><br>Une fois la théorie validée, place à la pratique ! Ton justificatif prouve que tu as les connaissances requises pour prendre la route.</p>
    <p>🎓&nbsp;&nbsp;<b>Passer ton examen</b><br>Pour passer l’examen du permis, ton justificatif de code doit dater de moins de 5 ans. Si tu n’es pas en règle, ton examinateur ne te laissera pas prendre le volant et ton examen sera annulé.</p>
    <p>🔎&nbsp;&nbsp;<b>Vigilance constante !</b><br>Nos équipes se réservent le droit de vérifier tes documents. Si ton justificatif n’est pas valide, nous devrons bloquer ton accès à la conduite jusqu’à régularisation de tes informations.</p>
    <button class="btn full-width margin-top-8" (click)="callhideModalJustifSavoirPlus()">Fermer</button>
  </modal-comp>

  <modal-comp [compOptions]="{'id': 'customModalLastObtainedBadge', closable: false}" *ngIf="displayModalLastObtainedBadge" (canClose)="hideModalLastObtainedBadge()">
    <div class="close-btn clickable" (click)="hideModalLastObtainedBadge()">
      <img src="assets/2022/icons/close-off.svg" alt="EnVoitureSimone" height="24">
    </div>
    <span class="congrats">Félicitations !</span>
    <span class="desc">Tu as débloqué une nouvelle réussite !</span>
    <div class="badge-container">
      <img class="badge" [src]="'assets/svg/gamification/badges/' + lastObtainedBadgeInDateRange.name + '.svg'">
    </div>
    <span class="badge-title"
      [ngClass]="{
        'color-account': lastObtainedBadgeInDateRange.category.classId === 'account',
        'color-code': lastObtainedBadgeInDateRange.category.classId === 'code',
        'color-prefecture-registration': lastObtainedBadgeInDateRange.category.classId === 'prefecture-registration',
        'color-code-exam': lastObtainedBadgeInDateRange.category.classId === 'code-exam',
        'color-driving-exam': lastObtainedBadgeInDateRange.category.classId === 'driving-exam',
        'color-driving-lesson': lastObtainedBadgeInDateRange.category.classId === 'driving-lesson'
      }"
      [innerHTML]="lastObtainedBadgeInDateRange.title"></span>
    <span class="badge-subtitle">{{ !!lastObtainedBadgeInDateRange.description ? lastObtainedBadgeInDateRange.description : lastObtainedBadgeInDateRange.subtitle }}</span>
    <button class="btn full-width" (click)="openLink('reussites')">Voir mes réussites</button>
    <confettis-comp [compOptions]="{'oneShoot': true}"></confettis-comp>
  </modal-comp>
</ion-content>
  
<modal-comp [compOptions]="{'id': 'customModalStartUpNEPH', closable: false}" *ngIf="displayModalStartUpNEPH" (canClose)="hideModalStartUpNEPH()" #modalStartUpNEPH>
  <div class="close-btn clickable" (click)="callHideModalStartUpNEPH()">
    <img src="assets/2022/icons/close-off.svg" alt="EnVoitureSimone" height="24">
  </div>
  <ng-container *ngIf="!fromNEPHInfosModal">
    <div class="content-wrapper">
      <h5>Renseigne ton numéro NEPH pour compléter ton dossier</h5>
      <div class="text-wrapper">
        <ul>
          <li><span class="bold">Tu as déjà ton NEPH ?</span> Indique-le dans la section "Attestation d'inscription".</li>
          <li><span class="bold">Tu n'as pas encore de NEPH ?</span> Inscris-toi sur l'ANTS (Agence Nationale des Titres Sécurisés) pour le récupérer. Tu y trouveras ton attestation d'inscription avec ton numéro NEPH, nécessaire pour passer le code et le permis.</li>
        </ul>
        <p>Besoin d'aide ? Consulte <span class="article-link clickable bold" (click)="openLink('howNEPH')">notre article</span> pour plus d'infos.</p>
      </div>
    </div>
    <div class="button-wrapper">
      <button class="btn full-width" (click)="callHideModalStartUpNEPH()">Je renseigne mon NEPH</button>
      <button class="btn light full-width" (click)="openLinkGouvNEPH()">Je m'inscris sur l'ANTS</button>
    </div>
  </ng-container>
  <ng-container *ngIf="fromNEPHInfosModal">
    <div class="content-wrapper">
      <h5>Tu as déjà été inscrit en auto-école ?</h5>
      <div class="text-wrapper">
        <p>Renseigne ton numéro NEPH dans la section <span class="bold">"Attestation d'inscription"</span> pour compléter ton dossier.</p>
        <p>Et si tu ne trouves pas ton numéro NEPH et que tu as besoin d'aide, lis <span class="article-link clickable bold" (click)="openLink('howNEPH')">notre article</span> qui t'expliquera comment faire pour le récupérer !</p>
      </div>
    </div>
  </ng-container>
</modal-comp>

<ion-footer *ngIf="!displayModalCategPermisChanged && !displayModalLicenseNumber && !displayModalCategPermis && !displayModalNEPH && !displayModalJustifSavoirPlus && !displayModalLastObtainedBadge">
  <footer-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></footer-nav-component>
</ion-footer>